import User from "@/models/user";
import {CHAT_MSG_ARRIVAL} from "@/constants/chat";

export default class ChatRoom {

    constructor(options) {
        this._id = options?._id || 0
        this.createdAt = options?.createdAt || ""
        this.updatedAt = options?.updatedAt || ""
        this.typeId = options?.typeId || 0
        this.name = options?.name || ""

        this.lastRoomId = options?.lastRoomId || 0
        this.lastFromUserId = options?.lastFromUserId || 0
        this.lastStatusId = options?.lastStatusId || 0
        this.lastContent = options?.lastContent || ""
        this.lastUpdatedAt = options?.lastUpdatedAt || ""
        this.lastFromUser = new User(options?.lastFromUser)
    }

    get isNew() {
        return this._id <= 0
    }

    get lastFromUserName() {
        return this.lastFromUser?.name ?? ""
    }

    get lastFromUserAvatarUrl() {
        return this.lastFromUser?.avatarUrl ?? ""
    }

    get hasUnread() {
        return this.lastStatusId === CHAT_MSG_ARRIVAL
    }

    // toData() {
    //     return {
    //         _id: this._id,
    //         userId: this.userId,
    //         typeId: this.typeId,
    //     }
    // }

    toJSON() {
        return {...this}
    }
}
